import React, {Component, PureComponent} from "react";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import {Server, Dictionary, ProductsListsContext, AlertModal, ModalHelper, helper}  from "./../app.js"; 

export default class ShelfSelecter extends PureComponent 
{
    static contextType = ProductsListsContext;

    use_length = false;
    modal = null;

    constructor (props)
    {
        super(props);

        const shelfId = this.props.init_shelf?.id;

        this.state = {
            shelfs: {},
            shelf_conns: [],
            stud_shelf_conns: [],
            id: shelfId ?? '',
            length: this.props.init_shelf?.use_length ?? this.props.init_shelf?.length ?? '',
            loading: false,
            alert_message: ''
        };

        if (shelfId && this.useLengthFor(shelfId))
        {
            this.use_length = this.props.init_shelf?.use_length ?? this.props.init_shelf.length;
        }        

        this.modal = new ModalHelper(this);

        this.isActive = this.isActive.bind(this);
        this.selectShelf = this.selectShelf.bind(this);
        this.setLength = this.setLength.bind(this);
        this.checkLength = this.checkLength.bind(this);
        this.modal.showProjectChangeWarning = this.modal.showProjectChangeWarning.bind(this.modal);
    }
    get shelf ()
    {
        const id = this.state.id;
        let shelf = null;

        if (id && id in this.state.shelfs)
        {
            shelf = this.state.shelfs[id];
        }
        return shelf;
    }
    isActive ()
    {
        return this.props.carrier_type && this.props.tray_type && (this.props.is_unitary || this.props.stud_articul);
    }
    loadShelfs ()
    {
        if (this.isActive())    
        {
            const carrierType = this.props.carrier_type, 
                queryParams = {
                    //tray_type: this.props.tray_type,
                    tray_articul: this.props.tray_articul,
                    shore_type: this.props.shore_type, 
                    carrier_type: carrierType, 
                    is_unitary: this.props.is_unitary
                };
            if (!this.props.is_unitary)
            {
                queryParams.stud_articul = this.props.stud_articul;
            }
            else
                queryParams.carrier = Dictionary.instance.get('carriers')?.[`'${carrierType}'`];

            this.setState({loading: true});

            //console.log(Dictionary.instance.get('carriers'));
            //console.log(carrierType);
            //console.log(queryParams);

            Server.instance
                .query('get_shelfs', queryParams)
                .then((recievedShelfs) =>
                {
                    helper.setStateWithRecievedItems(this, 'shelfs', recievedShelfs, function (fields, product)
                    {
                        ({
                            sectStudsCount: product.sect_studs_cnt = 1,
                            onlyWithHairpin: product.only_with_hairpin = false,
                            forTwoSides : product.for_two_sides = false,
                            trayLimitLogic: product.tray_limit_logic = 0,
                            trayLimitValue: product.tray_limit_value = 0
                        } = fields);
                        
                        ['tray_limit_logic', 'tray_limit_value'].forEach(field => 
                        {
                            product[field] = helper.toNumber(product[field]);
                        });
    
                        product.sect_studs_cnt = parseInt(product.sect_studs_cnt);
                        if (!product.sect_studs_cnt) product.sect_studs_cnt = 1;
                        
                        if (0 === product.only_with_hairpin) product.only_with_hairpin = false;
                        if (0 === product.for_two_sides) product.for_two_sides = false;
                    });

                })
                .catch(() => this.setState({shelfs: {}, loading: false}));
        }  
    }
    loadTrayShelfConn (id = '')
    {
        if (!id) id = this.state.id;
        
        const shelf = id && id in this.state.shelfs ? this.state.shelfs[id] : null,
            hasShelf = !helper.isNotObjectOrEmpty(shelf),
            shelfArticul = hasShelf ? shelf.articul : '',
            trayArticul = this.props.tray_articul;
        //console.log('loadTrayShelfConn', trayArticul, shelfArticul);
       
        if (trayArticul && shelfArticul)
        {
            const queryParams = {tray_articul: trayArticul, shelf_articul: shelfArticul};
            
            this.setState({loading: true});

            Server.instance
                .query('get_tray_shelf_conns', queryParams)
                .then((recievedTrayShelfConn) =>
                {
                    //console.log(recievedTrayShelfConn);
                    const shelf_conns = helper.setStateWithRecievedItems(this, 'shelf_conns', recievedTrayShelfConn);
                    //console.log(shelf_conns);
                    //this.setState({shelf_conns, loading: false});
                    this.props.on_select(shelf_conns, 'shelf_conns', false);
                })
                .catch(() => {
                    this.setState({shelf_conns: [], loading: false});
                    this.props.on_select([], 'shelf_conns', false);
                });
        }  
    }
    loadStudShelfConn (id = '')
    {
        if (!id) id = this.state.id;
        
        const shelf = id && id in this.state.shelfs ? this.state.shelfs[id] : null,
            hasShelf = !helper.isNotObjectOrEmpty(shelf),
            shelfArticul = hasShelf ? shelf.articul : '',
            studArticul = this.props.stud_articul;

        //console.log('loadStudShelfConn', studArticul, shelfArticul);

        if (studArticul && shelfArticul)
        {
            const queryParams = {stud_articul: studArticul, shelf_articul: shelfArticul};

            this.setState({loading: true});

            Server.instance
                .query('get_stud_shelf_conns', queryParams)
                .then((recievedStudShelfConn) =>
                {
                    //console.log(recievedStudShelfConn);
                    const stud_shelf_conns = helper.setStateWithRecievedItems(this, 'stud_shelf_conns', recievedStudShelfConn); 
                    //this.setState({stud_shelf_conns, loading: false});
//                    console.log(stud_shelf_conns);
                    this.props.on_select(stud_shelf_conns, 'stud_shelf_conns', false);
                })
                .catch(() => {
                    this.setState({stud_shelf_conns: [], loading: false});
                    this.props.on_select([], 'stud_shelf_conns', false);
                });
        }
    }
    selectShelf (e)
    {
        const id = e.target.value,
            newShelf = id ? helper.copyObject(this.state.shelfs[id]) : null;

        if (newShelf)
        {            
            const useLength = this.useLengthFor(id);

            this.setState({id, length: useLength ? newShelf.length : ''});

            this.use_length = newShelf.use_length = useLength ? newShelf.length : false;
            this.props.on_select(newShelf, 'shelf');

            this.loadStudShelfConn(id);
            this.loadTrayShelfConn(id);            
        } 
        else
        {
            this.use_length = false;
            this.setState({id: '', length: '', shelf_conns: [], stud_shelf_conns: []});

            this.props.on_select(null, 'shelf');
        }
    }
    useLength()
    {
        return this.useLengthFor(this.shelf?.id);
    }
    useLengthFor(id)
    {
        return id && this.state.shelfs?.[id] && helper.isMeterProduct(this.state.shelfs[id]);
    }
    setLength (e)
    {
        const shelf = helper.copyObject(this.shelf),
            isUnitary = this.props.is_unitary;

        if (shelf && this.useLength())
        {
            const lengthValue = e.target.value;

            if ('' !== lengthValue)
            {
                const length = parseInt(lengthValue);

                if (isNaN(length) || (length && length < 0))
                {
                    this.setState({alert_message: `Некорректное значение длины ${isUnitary ? 'подвеса' : 'полки'}`});
                }
                else if (!length)
                {
                    this.setState({alert_message: `Не задана длина ${isUnitary ? 'подвеса' : 'полки'}`});
                }
                else if (length)
                {
                    this.setState({length});

                    if (length >= 100)
                    {
                        this.use_length = shelf.use_length = length;

                        this.props.on_select(shelf, 'shelf');
                    }
                }
            }
            else
                this.setState({length: ''});
        }
    }    
    checkLength (e)
    {
        if (this.shelf && this.useLength() && e.target.value < 100)
        {
            const shelf = helper.copyObject(this.shelf);

            this.use_length = shelf.use_length = shelf.length;

            this.setState({
                alert_message: 'Значение длины полки не может быть меньше 100', 
                length: shelf.use_length 
            });

            this.props.on_select(shelf, 'shelf');
        }        
    } 
    componentDidMount() 
    {
        this.loadShelfs();
        this.loadStudShelfConn();
        this.loadTrayShelfConn();
    }
    render () 
    {   
        const shelfsList = Object.keys(this.state.shelfs)
                            .filter(id => 
                            {
                                const carrierType = this.props.carrier_type,
                                    carrier = Dictionary.instance.get('carriers')?.[`'${carrierType}'`],
                                    shelfArticul = this.state.shelfs[id].articul;

                                return 'Стена' != carrier || shelfArticul.indexOf('КОД') < 0;
                            })        
                            .map(id => 
                            {
                                return <option key={id} value={id}>{'articul' == this.context ? this.state.shelfs[id].articul : this.state.shelfs[id].name}</option>;
                            }),
            isUnitary = this.props.is_unitary,
            useLength = this.useLength(),
            disabled = !this.isActive() || !shelfsList.length;
        shelfsList.unshift(<option key="none" value="">{isUnitary ? 'Выберите подвес:' : 'Выберите полку:'}</option>);

        //if (this.props.is_unitary)
        //{
            /*
            shoreSelecter = <><Form.Group>
                <Form.Label className={disabled ? 'text-muted' : ''}>{isUnitary ? 'Подвес' : 'Полка'}:{this.state.loading ? <Spinner animation="border" variant="primary" size="sm" className="ml-1" /> : ''}</Form.Label>
                <Form.Row>
                    <Col md={!true 
                                ? (isUnitary ? 8 : 6)
                                : 7}>
                        <Form.Control onChange={this.selectShelf} value={this.state.id} disabled={disabled} as="select" custom>                            
                            {shelfsList}
                        </Form.Control>      
                    </Col> 
                    {true
                    ? <Col md={5}>
                        <Form.Control onChange={this.setLength} onBlur={this.checkLength} value={this.state.length} disabled={disabled} type="text" placeholder="Точная длина, мм" />
                    </Col>
                    : ''}
                </Form.Row>
            </Form.Group>
            <AlertModal on_close={() => this.setState({alert_message: ''})} message={this.state.alert_message} /></>;
            */
            /*
             onBlur={this.roundLength}

            {useLength
                ? <Form.Group as={Col} md={5}>
                    <Form.Label className={disabled ? 'text-muted' : ''}>Точная длина:</Form.Label>
                    <Form.Control onChange={this.setLength} onBlur={this.roundLength} value={this.state.length} disabled={disabled} type="text" placeholder="Точная длина, мм" />
                </Form.Group>
                : ''}
        }
        else
        {
            shoreSelecter = <Form.Row>
                <Form.Group as={Col} md={6}>
                    <Form.Label className={disabled ? 'text-muted' : ''}>Полка:{this.state.loading ? <Spinner animation="border" variant="primary" size="sm" className="ml-1" /> : ''}</Form.Label>
                    <Form.Control onChange={this.selectShelf} value={this.state.id} disabled={disabled} as="select" custom>
                        {shelfsList}
                    </Form.Control>
                </Form.Group>
            </Form.Row>;
        }*/

        return <><Form.Group as={Col} md={!useLength 
                                            ? (isUnitary ? 8 : 6)
                                            : 7}>
                    <Form.Label className={disabled ? 'text-muted' : ''}>{isUnitary ? 'Подвес' : 'Полка'}:{this.state.loading ? <Spinner animation="border" variant="primary" size="sm" className="ml-1" /> : ''}</Form.Label>
                    <Form.Control onChange={this.selectShelf} onClick={this.modal.showProjectChangeWarning} value={this.state.id} disabled={disabled} as="select" custom>
                        {shelfsList}
                    </Form.Control>
                </Form.Group>
                {useLength
                ? <Form.Group as={Col} md={5}>
                    <Form.Label className={disabled ? 'text-muted' : ''}>Точная длина полки:</Form.Label>
                    <Form.Control onChange={this.setLength} onBlur={this.checkLength} onClick={this.modal.showProjectChangeWarning} value={this.state.length} disabled={disabled} type="text" placeholder="Точная длина, мм" />
                </Form.Group>
                : ''}
                <AlertModal on_close={() => this.setState({alert_message: ''})} message={this.state.alert_message} /></>;
    }
}
